import type { ReactNode } from 'react';
import { ExecutionNeoIcon } from '@terra/ui-design-system';
import {
  Home03Icon,
  Globe02Icon,
  File01Icon,
  Settings01Icon,
  GitCompareIcon,
  Target03Icon,
  Alert01Icon,
  CableIcon,
  FlashIcon,
  ReplaceIcon,
  ReplayIcon,
  CursorPointer01Icon,
  TerminalIcon,
  ComputerIcon,
  HierarchyIcon,
  Shapes01Icon,
  Layers01Icon,
  PlayIcon,
  SourceCodeIcon,
  BookOpen01Icon,
  Edit03Icon,
  Maximize02Icon,
  PlayCircleIcon,
  WorkHistoryIcon,
} from '@terra/ui-icons';
import type { MainContentTab, FindingTabMode } from '../../store/layoutStore';
import { FINDING_TAB_MODE } from '../../store/layoutStore';

type MainContentTabIconOptions = {
  size?: number;
  strokeWidth?: number;
  mode?: FindingTabMode;
};

export const getMainContentTabIcon = (
  type: MainContentTab,
  { size = 16, strokeWidth = 1.75, mode }: MainContentTabIconOptions = {},
): ReactNode => {
  const iconProps = { size, strokeWidth };

  switch (type) {
    case 'welcome':
      return <Home03Icon {...iconProps} />;
    case 'application':
      return <Home03Icon {...iconProps} />;
    case 'network-graph':
      return <HierarchyIcon {...iconProps} />;
    case 'domain':
      return <Globe02Icon {...iconProps} />;
    case 'endpoint':
    case 'unverified-endpoint':
      return <TerminalIcon {...iconProps} />;
    case 'webpage':
      return <ComputerIcon {...iconProps} />;
    case 'settings':
      return <Settings01Icon {...iconProps} />;
    case 'comparer':
      return <GitCompareIcon {...iconProps} />;
    case 'executions':
      return <ExecutionNeoIcon size={size} />;
    case 'executions-list':
      return <PlayIcon {...iconProps} />;
    case 'agent-executions-list':
      return <PlayIcon {...iconProps} />;
    case 'signal':
    case 'signals-list':
      return <Target03Icon {...iconProps} />;
    case 'finding':
      if (mode === FINDING_TAB_MODE.EDIT) {
        return <Edit03Icon {...iconProps} />;
      }

      return <Alert01Icon {...iconProps} />;
    case 'findings-list':
      return <Alert01Icon {...iconProps} />;
    case 'assets-list':
      return <Shapes01Icon {...iconProps} />;
    case 'reports-list':
      return <File01Icon {...iconProps} />;
    case 'code-list':
      return <SourceCodeIcon {...iconProps} />;
    case 'skill':
    case 'skills-list':
    case 'skill-editor':
      return <BookOpen01Icon {...iconProps} />;
    case 'requests':
      return <WorkHistoryIcon {...iconProps} />;
    case 'websocket':
      return <CableIcon {...iconProps} />;
    case 'intercept':
      return <FlashIcon {...iconProps} />;
    case 'match-replace':
      return <ReplaceIcon {...iconProps} />;
    case 'replay':
      return <ReplayIcon {...iconProps} />;
    case 'interact':
      return <CursorPointer01Icon {...iconProps} />;
    case 'proxy-settings':
      return <Settings01Icon {...iconProps} />;
    case 'hitl-edit':
      return <Edit03Icon {...iconProps} />;
    case 'http-viewer':
      return <Maximize02Icon {...iconProps} />;
    case 'node-args-viewer':
      return <File01Icon {...iconProps} />;
    case 'browser-stream':
      return <PlayCircleIcon {...iconProps} />;
    case 'plan-viewer':
      return <File01Icon {...iconProps} />;
    case 'surface-asset':
    case 'ai-component':
      return <Layers01Icon {...iconProps} />;
    default:
      return <File01Icon {...iconProps} />;
  }
};
